import React from 'react';
import './BoxLegend.css';

function BoxLegend() {
    const legendItems = [
      { label: "MS", color: "rgba(255, 51, 51, 0.7)" }, // bright red
      { label: "SAR", color: "rgba(102, 255, 102, 0.7)" }, // bright green
      { label: "RGB", color: "rgba(51, 102, 255, 0.7)" }, // bright blue
      { label: "RGB, NIR" || "RGB,NIR", color: "rgba(204, 51, 204, 0.7)" }, // bright purple
    ];

  return (
    <div className="legend">
      {legendItems.map((item, index) => (
        <div key={index} className="legend-item">
          <div
            className="legend-color"
            style={{ backgroundColor: item.color }}
          ></div>
          <div className="legend-label">{item.label}</div>
        </div>
      ))}
    </div>
  );
}

export default BoxLegend;
